import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const generatePreviewDiscountCode = {
  name: "generatePreviewDiscountCode" as const,
  input: z.object({ discountId: zExt.objectId() }),
  output: z.object({ discountCode: z.string() }),
};
